import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function Category2productInfo(){
  const { category2productObj} = useSelector((state)=>state.manufslice.category2productDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height } }}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white'}}
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Business Id"  value={ category2productObj.businessid!==null && category2productObj.businessid!==undefined?category2productObj.businessid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="title"  value={ category2productObj.title!==null && category2productObj.title!==undefined?category2productObj.title:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Category Id"  value={ category2productObj.categoryid!==null && category2productObj.categoryid!==undefined?category2productObj.categoryid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Product Id"  value={ category2productObj.productid!==null && category2productObj.productid!==undefined?category2productObj.productid:'NOT KNONWN' }/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}